<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('miscUploads') }}</h2>
				<ja-button
					v-if="showCreate"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('newUpload') }}</ja-button
				>
			</div>
			<!-- Table Misc. upload -->
			<ja-misc-uploads-table
				v-if="showCreate && sponsorLogosData"
				:data="sponsorLogosData"
				@editRow="handleEditRow"
				@deleteRow="handleDeleteRow"
			></ja-misc-uploads-table>
			<!-- Create new Misc. upload -->
			<ja-create-misc-uploads
				v-if="!showCreate"
				:show="!showCreate"
				:data-edit="dataEdit"
				@saveSponsorLogo="handleSaveSponsorLogo"
				@cancel="handleCancel"
			></ja-create-misc-uploads>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import MiscUploadsTable from '../miscUploads/MiscUploadsTable';
import CreateMiscUploads from '../miscUploads/CreateMiscUploads';
import SponsorLogosServices from '@/services/cms/SponsorLogosServices';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaMiscUploadsTable: MiscUploadsTable,
		jaCreateMiscUploads: CreateMiscUploads,
		jaButton: Button
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showCreate: true,
			sponsorLogosData: null,
			dataEdit: null
		};
	},
	computed: {
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.showCreate = true;
			this.getSponsorLogos();
		},
		questionTypeIndex(newIndex) {
			this.updateQuestionFormat(newIndex);
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showCreate = true;
			} else {
				this.showCreate = false;
			}
		}
	},
	mounted() {
		if (this.selectedFacilityId != null) {
			this.$store.commit('setLoading', true);
			this.getSponsorLogos();
		}
	},
	methods: {
		async getSponsorLogos() {
			const data = await SponsorLogosServices.getAll(this.selectedFacilityId);
			this.sponsorLogosData = data;
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const data = await SponsorLogosServices.getById();
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleEditRow(rowData) {
			const data = await SponsorLogosServices.getById(rowData.sponsorLogo_ID);
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleSaveSponsorLogo(sponsorLogoData) {
			this.$store.commit('setLoading', true);
			await SponsorLogosServices.update(sponsorLogoData);
			await this.getSponsorLogos();
			this.showCreate = true;
		},
		async handleDeleteRow(rowData) {
			this.$store.commit('setLoading', true);
			await SponsorLogosServices.deleteById(rowData.sponsorLogo_ID);
			await this.getSponsorLogos();
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getSponsorLogos();
			this.showCreate = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
